import {combineReducers} from '@reduxjs/toolkit'
import {installedApps} from '../../../../commons/reducers/installed-apps'
import {error} from './error'
import {event} from './event'
import {filter} from './filter'
import {member} from './member'
import {modals} from './modals'
import {schedule} from './schedule'

export const rootReducer = combineReducers({schedule, event, filter, modals, error, installedApps, member})

export type State = ReturnType<typeof rootReducer>
